import React from "react";
import { Snackbar, Alert } from "@mui/material";

/**
 * Notification snackbar for displaying feedback to the user
 */
const NotificationSnackbar = ({ open, message, severity, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={onClose}
        severity={severity || "info"}
        variant="filled"
        sx={{
          width: "100%",
          borderRadius: "8px",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;
